import { useAuth } from '@ben/shared/providers/auth-provider';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { getMe } from '../../api/ea/me';
import type { IUser } from '../../types/user';
import { createInvalidateHook, createSetQueryHook } from './use-query-base';

export type IUserError = AxiosError<{ error_code: string; detail: string }>;

const QUERY_KEY = 'me';

const getKey = () => {
  return [QUERY_KEY];
};

export const useQueryMe = (
  options?: Omit<UseQueryOptions<IUser, IUserError>, 'queryKey' | 'queryFn'>
) => {
  const { isAuthenticated } = useAuth();
  const result = useQuery<IUser, IUserError>({
    ...options,
    enabled: isAuthenticated && options?.enabled !== false,
    queryKey: getKey(),
    queryFn: getMe,
    meta: {
      cancelQueriesOnError: true,
    },
  });
  return {
    ...result,
    isLoading: isAuthenticated ? result.isLoading : false,
  };
};

export const useInvalidateMe = createInvalidateHook(getKey);

export const useSetQueryMe = createSetQueryHook<undefined, IUser>(getKey);
